import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

// react-router v5 guarded route. `isPrivate` requires auth; visiting /login
// while authenticated bounces to the app.
const Route = ({ component: Component, isPrivate = false, isStaff = false, isGovernance = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  if (isPrivate && !isAuth) {
    return <Redirect to={{ pathname: "/login" }} />;
  }

  // Onboarding v3: a recepção (/recepcao) é opt-in pelo botão "Começar" — NÃO
  // forçamos o 1º acesso para lá. (Funil forçado removido de propósito.)

  // backoffice interno: para quem não é da equipe a rota simplesmente não
  // existe (o servidor também responde 404 — ver middleware/isStaff)
  if (isStaff && !(user && user.isStaff)) {
    return <Redirect to={{ pathname: "/" }} />;
  }

  // telas de dinheiro (receita, preços): só governança
  if (isGovernance && !(user && user.canSeeMoney)) {
    return <Redirect to={{ pathname: "/admin" }} />;
  }

  if (!isPrivate && isAuth && rest.path === "/login") {
    return <Redirect to={{ pathname: "/numbers" }} />;
  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;
